import { combineReducers } from 'redux';
import auth_code from './reducers/auth_code';
import content from './reducers/content';
import current_user from './reducers/current_user';
import customer from './reducers/customer';
import membership from './reducers/membership';
import notifications from './reducers/notifications';
import section from './reducers/section';
import terms from './reducers/terms';
import currentTerm from './reducers/current_term';
import manage_content from 'reducers/manage_content';
import requestQueue, * as fromRequestQueue from './reducers/request_queue';

import { reducer as loader } from './loader';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as fetchTree } from 'fetch-tree';
import auralNotification from 'reducers/aural_notification';
import skipLink from 'reducers/skip_link';

export default combineReducers({
    auth_code,
    content,
    current_user,
    customer,
    membership,
    notifications,
    section,
    terms,
    currentTerm,
    loader,
    routing,
    requestQueue,
    fetchTree,
    manage_content,
    auralNotification,
    skipLink,
});

export const selectNextRequest = state =>
    fromRequestQueue.selectNextRequest(state.requestQueue);



// WEBPACK FOOTER //
// ./src/root_reducer.js